import { withProps, compose, withStateHandlers } from 'recompose'
import withType from 'components/common/hoc/withType'
import MyGarageEducationContentDetails from './MyGarageEducationContentDetails'

const withEducationalMaterialsStateHandlers = withStateHandlers({
  togglePlayPause: () => {},
  isPlaying: null
}, {
  setTogglePlayPause: () => (togglePlayPause) => ({
    togglePlayPause
  }),
  setIsPlaying: () => (isPlaying) => ({
    isPlaying
  })
})

const withMockEducationalMaterialsProps = withProps(({ articleDetailList }) => ({
  educationalMaterials: articleDetailList
}))

const withCarouselConfig = withProps(({ educationalMaterials }) => {
  const totalItemsCount = educationalMaterials.length

  const baseConfig = {
    slidesToScroll: 1,
    slidesToShow: 1,
    dots: true,
    draggable: true,
    arrows: false,
    infinite: true,
    autoplaySpeed: 3000,
    variableWidth: false,
    accessibility: true
  }

  return {
    carouselConfig: baseConfig,
    totalItemsCount
  }
})

export default compose(
  withType({ type: ['MyGarageEducationContentDetails', 'MyVehicleEducationContentDetails']}),
  withEducationalMaterialsStateHandlers,
  withMockEducationalMaterialsProps,
  withCarouselConfig
)(MyGarageEducationContentDetails)
